import type { ReferralCouponFragment } from '@drycut/graphql';

import { Navigation } from '@drycut/navigation';
import { Heading, Para, Stack } from '@drycut/ui-components';

import ExpirationDate from '../ExpirationDate';
import { InputFieldCopier } from '../InputFieldCopier';
import { InvalidCoupon } from '../InvalidCoupon';
import Action from '../Redemption/Action';
import InvitationSteps from './InvitationSteps';
import SocialLinks from './SocialLinks';

type Props = {
  coupon?: ReferralCouponFragment;
};

export function Invitation({ coupon }: Props): React.ReactElement {
  if (!coupon) {
    return <InvalidCoupon couponExpired={false} />;
  }

  const validCoupon = coupon.type === 'Coupons::NewCustomerReferral' && !coupon.expired;

  if (!validCoupon) {
    return <InvalidCoupon couponExpired={!!coupon.expired} expiresAt={coupon.expiresAt} />;
  }

  const referralUrl = `${Navigation.REFERRAL_URL}/referral/${coupon.code}`;

  return (
    <Stack gap={6} className="items-center text-center text-pretty">
      <Heading variant="h2">13 CHF für Deine Freunde & Dich</Heading>

      <Stack gap={2}>
        <Para>
          Warst Du mit Deinem Besuch bei DRYCUT zufrieden? Dann würden wir uns über eine
          Weiterempfehlung an Deine Freunde freuen.
        </Para>

        <Para>
          Als Dankeschön bekommen sie ihren ersten DRYCUT für{' '}
          <strong className="font-aribaubold">CHF 29 (statt CHF 42)</strong> und Du – pro geworbenen
          Neukunden – ebenfalls einen CHF 13 Gutschein.
        </Para>

        <InvitationSteps couponCode={coupon.code} />

        <Stack gap={4} className="my-4">
          <Action title="Freunde direkt einladen">
            <SocialLinks code={coupon.code} />
          </Action>

          <Action title="Link kopieren & teilen">
            <InputFieldCopier textToCopy={referralUrl} />
          </Action>
        </Stack>

        <ExpirationDate couponExpiration={coupon.expiresAt} />
      </Stack>
    </Stack>
  );
}
